module.exports = __webpack_public_path__ + "img/1F1F8-1F1F4.fcc9e470.svg";